var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:['authorization-hours-list', _vm.direction]},_vm._l((_vm.durations),function(item,index){return _c('li',{key:index,staticClass:"authorization-hours"},[_c('span',{staticClass:"authorization-hours__label"},[_vm._v(_vm._s(item.category)+":")]),_vm._v(" "+_vm._s(item.credits)+" "+_vm._s(_vm.authorizationLabel)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }